import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Form as AntForm } from 'antd';
import { Button, Form, Input, Select, Column, Row } from '@bancobarigui/barihaus';
import { MaskedInput } from '@/shared/components/MaskedInput';

export function ContactList() {
  return (
    <div className="space-y-4">
      <AntForm.List name="contacts">
        {(fields, { add, remove }) => (
          <>
            {fields.map((field) => (
              <div key={field.key} className="border border-gray-200 rounded-lg p-4 mb-4 relative">
                <Row gutter={[16, 16]}>
                  <Column span={12}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'contactName']}
                      label="Nome do Contato"
                      rules={[{ required: true, message: 'Informe o nome do contato.' }]}
                      style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="Nome completo" />
                    </Form.Item>
                  </Column>

                  <Column span={12}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'email']}
                      label="E-mail"
                      rules={[
                        { required: true, message: 'Informe o e-mail.' },
                        { type: 'email', message: 'E-mail inválido' },
                      ]}
                      style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="contato@exemplo.com" type="email" />
                    </Form.Item>
                  </Column>

                  <Column span={24}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'contactType']}
                      label="Tipo de Contato"
                      rules={[{ required: true, message: 'Informe o tipo do contato.' }]}
                      style={{ marginBottom: 0 }}
                    >
                      <Select
                        placeholder="Selecione o tipo"
                        options={[
                          { label: 'Proprietário', value: '1', disabled: false },
                          { label: 'Inquilino', value: '2', disabled: false },
                          { label: 'Corretor', value: '3', disabled: false },
                          { label: 'Síndico', value: '4', disabled: false },
                        ]}
                      />
                    </Form.Item>
                  </Column>

                  <Column span={8}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'mobilePhone']}
                      label="Celular"
                      style={{ marginBottom: 0 }}
                    >
                      <MaskedInput mask="(00) 00000-0000" placeholder="(00) 00000-0000" autoComplete="tel" />
                    </Form.Item>
                  </Column>

                  <Column span={8}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'residentialPhone']}
                      label="Telefone Residencial"
                      style={{ marginBottom: 0 }}
                    >
                      <MaskedInput mask="(00) 0000-0000" placeholder="(00) 0000-0000" autoComplete="tel" />
                    </Form.Item>
                  </Column>

                  <Column span={8}>
                    <Form.Item
                      {...field}
                      name={[field.name, 'commercialPhone']}
                      label="Telefone Comercial"
                      style={{ marginBottom: 0 }}
                    >
                      <MaskedInput mask="(00) 0000-0000" placeholder="(00) 0000-0000" autoComplete="tel" />
                    </Form.Item>
                  </Column>
                </Row>

                {fields.length > 0 && (
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => remove(field.name)}
                    className="absolute top-2 right-2"
                  >
                    Remover
                  </Button>
                )}
              </div>
            ))}

            <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />} className="w-full">
              Adicionar contato
            </Button>
          </>
        )}
      </AntForm.List>
    </div>
  );
}
